import {
  faArrowRightArrowLeft,
  faRightToBracket,
  faRightFromBracket,
  faScaleBalanced,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card } from 'primereact/card'
import React from 'react'
import { VehicleFlowCounts } from '../../hooks/useVehicleFlow'
import './dashboard-vehicle-flow.scss'

export interface DashboardVehicleFlowProps {
  flow: VehicleFlowCounts
}

const DashboardVehicleFlow: React.FC<DashboardVehicleFlowProps> = ({
  flow,
}) => {
  const cards = [
    {
      label: 'Entradas',
      count: flow.entries,
      icon: faRightToBracket,
      color: '#10B981',
      bgColor: 'rgba(16, 185, 129, 0.3)',
    },
    {
      label: 'Saídas',
      count: flow.exits,
      icon: faRightFromBracket,
      color: '#f01657',
      bgColor: 'rgba(181, 11, 62, 0.3)',
    },
    {
      label: 'Saldo (dentro agora)',
      count: flow.balance,
      icon: faScaleBalanced,
      color: '#22d3ee',
      bgColor: 'rgba(34, 211, 238, 0.3)',
    },
  ]

  return (
    <div className='vehicle-flow-section'>
      <div className='section-header mb-3'>
        <h3 className='section-title'>
          <FontAwesomeIcon
            icon={faArrowRightArrowLeft}
            className='mr-2'
          />
          Fluxo de Entrada e Saída
        </h3>
        <p className='section-subtitle'>
          Balanço direcional de veículos no período selecionado
        </p>
      </div>
      <div className='grid'>
        {cards.map((card) => (
          <div
            key={card.label}
            className='col-12 sm:col-4'
          >
            <Card className='vehicle-flow-card'>
              <div className='vehicle-flow-card-inner'>
                <div
                  className='vehicle-flow-icon'
                  style={{
                    backgroundColor: card.bgColor,
                    border: `2px solid ${card.color}`,
                  }}
                >
                  <FontAwesomeIcon
                    icon={card.icon}
                    style={{ color: card.color }}
                    size='lg'
                  />
                </div>
                <div className='vehicle-flow-info'>
                  <div className='vehicle-flow-count'>
                    {card.count.toLocaleString('pt-BR')}
                  </div>
                  <div className='vehicle-flow-label'>{card.label}</div>
                </div>
              </div>
            </Card>
          </div>
        ))}
      </div>
    </div>
  )
}

export default DashboardVehicleFlow
